module.exports = {
    min: -10,
    max: 100
};
